import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Grid } from 'src/components/HTKit/Grid';
import { BackComponent } from 'src/containers/AddSkuPage/QuestionsFlowPage/Parts/QAPage';
import { CalloutBox, CALLOUTBOX_THEMES } from 'Elements/CalloutBox';
import styles from './styles.scss';

const QuestionsHeader = ({ alert = undefined, question, hint = '' }) => {
  const headerStyles = cn('site-v2', styles.headerWrapper);
  const noteStyles = cn(styles.note);
  return (
    <div className={headerStyles}>
      <BackComponent />
      <h4>{question}</h4>
      {hint && <div className={noteStyles}>{hint}</div>}
      {alert && (
        <Grid.FullWidth classes={styles.gridContainer}>
          <Grid.Row>
            <Grid.Column
              sm={4}
              mdOffset={2}
              md={4}
              lgOffset={0}
              lg={12}
              classes={styles.customColumn}
            >
              <CalloutBox
                className="marginTop-medium text-align-left"
                theme={CALLOUTBOX_THEMES.CRITICAL}
                header={alert.title}
                text={alert.content}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid.FullWidth>
      )}
    </div>
  );
};

QuestionsHeader.propTypes = {
  question: PropTypes.string,
  hint: PropTypes.string,
  alert: PropTypes.shape({ title: PropTypes.string, content: PropTypes.string }),
};

export default React.memo(QuestionsHeader);

/*
QuestionsHeader component:

Usage:

import { QuestionsHeader } from './Parts';

<QuestionsHeader question="What type of surface will the TV be mounted to?" note="We do not mount on plaster, tile or stone facades" />

Props:
question: String (Would be the question that has a property with string value to be shown on the page)
note: String (If a question is associated with a note, this is where it'll render)

Note: This may change based on how question data is created.
*/
